import { render, staticRenderFns } from "./ManagmentLoan.vue?vue&type=template&id=85be0f6e&"
import script from "./ManagmentLoan.vue?vue&type=script&lang=js&"
export * from "./ManagmentLoan.vue?vue&type=script&lang=js&"
import style0 from "./ManagmentLoan.vue?vue&type=style&index=0&id=85be0f6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports